import { DriverModel } from "../../components/DriverModel/Driver"
import { Bicycle } from "../../components/DriverModel/Bicycle"
import { Vehicle } from "../../components/DriverModel/Vehicle"
import { Simulation } from "../../components/DriverModel/Simulation"
import { Metrics } from "../../components/DriverModel/Metrics"

import simulationParams from "./simulationParams"

const dt = simulationParams.state.simulation[1];

const driverModel = simulationParams.state.driverModel; //default values of driver model
var DRIVERMODEL = new DriverModel(driverModel[0], driverModel[1], driverModel[2], driverModel[3], driverModel[4], driverModel[5]);
DRIVERMODEL.dt = dt;

const vehicle = simulationParams.state.vehicle;
var VEHICLE = new Vehicle(vehicle, dt);
const bicycle = simulationParams.state.bicycle;
var BICYCLE = new Bicycle(bicycle, dt);

const state = {
    simulation: new Simulation(DRIVERMODEL, new Metrics(), VEHICLE, BICYCLE)
}

// getters
const getters = {}

// actions
const actions = {
    initialize(store) {
        store.state.simulation.reinit(simulationParams.state);
        store.state.simulation.generate();
    },
    update(store, simulationParams) {
        store.state.simulation.reinit(simulationParams);
        store.state.simulation.generate();
    }
}

// mutations
const mutations = {

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}